// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { renderImageMeta } from '../../core/render/visualUtils';
import type { Device } from '../model/Device.model';
import Loader from '../../elements/Loader';
import LoadFailed from '../../elements/LoadFailed';
import ErrorCapsule from '../../core/exceptions/ErrorCapsule';
import type { Brand } from '../model/Brand.model';
import { useDialog } from '../../elements/Dialog';
import CanEdit from '../../elements/CanEdit';
import FolderPickButton from '../../elements/FolderPickButton';

export type DevicesListPageViewProps = {
  brand: ?Brand,
  devices: null | Array<Device> | ErrorCapsule,
  rootProps: Object,
  isDragActive: boolean,
  notice: ?string,
  onDeleteDevice: (id: string) => void,
  onFolderFiles: (files: Array<File>) => void,
}

export default function DevicesListPageView({
  brand,
  devices,
  rootProps,
  isDragActive,
  notice,
  onDeleteDevice,
  onFolderFiles,
}: DevicesListPageViewProps) {
  const { t } = useTranslation();
  const { confirm } = useDialog();

  if (!devices) return <Loader />;
  if (devices instanceof ErrorCapsule) return <LoadFailed error={devices} />;

  return (
    <div
      className="devices-list"
      {...rootProps}
      style={{ background: isDragActive ? 'yellow' : null }}
    >
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/library/brands/">Бренды</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">{brand.name}</li>
        </ol>
      </nav>
      <h1>Управление моделями</h1>

      {notice && <div className="alert alert-warning">{notice}</div>}

      <CanEdit>
        <p className="text-muted small mb-1">
          Модель с лекалами можно загрузить папкой: кнопкой или перетащив папку сюда. Внутри
          файлы .prn и картинки .jpg, .png, можно во вложенных папках.
        </p>
      </CanEdit>
      <div className="mb-2 list-toolbar">
        <CanEdit>
          <FolderPickButton label="загрузить папку модели" onFiles={onFolderFiles} />
          <Link to={`/library/device-add/${brand.id}/`} className="btn btn-primary btn-sm">добавить модель</Link>
        </CanEdit>
      </div>
      <table className="table">
        <tbody>
          {devices.map(({
            id,
            deviceType: { name: deviceTypeName },
            name,
            preview,
          }) => (
            <tr key={id} className="devices-list__device">
              <td className="text-center w-25">{preview ? renderImageMeta(preview.fit) : null}</td>
              <td className="align-middle"><Link to={`/library/variants/${id}/`}>{name}</Link></td>
              <td className="align-middle">{deviceTypeName}</td>
              <td className="align-middle"><CanEdit>
                <div className="row-actions">
                  <Link to={`/library/device-edit/${id}/`} className="btn btn-sm">
                    изменить
                  </Link>
                  <button
                    type="button"
                    className="btn btn-sm row-actions__danger"
                    onClick={e => confirm({
                      renderBody: () => `Удаляем ${name}?`,
                      handler: () => onDeleteDevice(id),
                    })}
                  >
                    удалить
                  </button>
                </div>
              </CanEdit></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
